<div class="page-container w-screen h-screen">
  <div
    class="white-card w-[25rem] flex flex-col gap-[1.25rem] px-[1.5rem] py-[2rem] scale-[3] lg:scale-100"
    [formGroup]="newUserForm">
    <div class="flex justify-center">
      <app-orca-logo [logoWidthRem]="7" [logoHeightRem]="2" [logoType]="'black'"/>
    </div>
    <span class="font-1 text-center bold600 black-12 line-height-120">
      Create account
    </span>
    <app-input
      data-qa="new-user-name"
      tabindex="1"
      [required]="true"
      [autofocus]="true"
      [formControlName]="'name'"
      [title]="'Name'"
      [placeholder]="'Name'"
      [maxLength]="256"
    />
    <app-input
      data-qa="new-user-company"
      tabindex="2"
      [required]="true"
      [formControlName]="'company'"
      [title]="'Company'"
      [placeholder]="'Company'"
      [maxLength]="256"
    />
    <app-input
      data-qa="new-user-position"
      tabindex="3"
      [required]="true"
      [formControlName]="'position'"
      [title]="'Position'"
      [placeholder]="'Position'"
      [maxLength]="256"
    />
    <div class="flex items-end justify-center">
      <app-input
        data-qa="new-user-country-code"
        class="w-[20%] code-input"
        tabindex="4"
        [formControlName]="'countryCode'"
        prefixText="+"
        [maxLength]="4"
        [placeholder]="'1'"
        [title]="'Phone'"
        [required]="true"
        [bottomText]="newUserForm.controls.countryCode.invalid && newUserForm.controls.countryCode.touched ? 'Required' : ''"
        [additionalClass]="newUserForm.controls.countryCode.invalid && newUserForm.controls.countryCode.touched ? 'error' : ''"
        (blurEmitter)="newUserForm.controls.countryCode.markAsTouched()"
      />
      <app-input
        data-qa="new-user-phone"
        class="w-[80%] grow  phone-input"
        tabindex="5"
        [formControlName]="'phone'"
        [placeholder]="'Phone number'"
        [bottomText]="newUserForm.controls.phone.invalid && newUserForm.controls.phone.touched ? 'Please enter a valid phone number' : ''"
        [additionalClass]="newUserForm.controls.phone.invalid && newUserForm.controls.phone.touched ? 'error' : ''"
        [maxLength]="15"
        (blurEmitter)="newUserForm.controls.phone.markAsTouched()"
      />
    </div>
    <div class="flex flex-col gap-[0.5rem]">
      <app-checkbox
        data-qa="new-user-agreements"
        [formControlName]="'agreements'"
        [checked]="newUserForm.value.agreements"
        [required]="true"
        (checkBoxClicked)="newUserForm.controls.agreements.setValue($event)">
          <span class="font-4 bold400 black-10">
            By clicking continue button below, you agree to<br>
            <a data-qa="terms-of-use" class="link-color underline" [href]="WEBSITE_PROD_ORCA_TERMS_OF_USE" [target]="'_blank'">the Terms & Conditions</a> and
            <a data-qa="privacy-policy" class="link-color underline" [href]="WEBSITE_PROD_ORCA_PRIVACY_POLICY" [target]="'_blank'">Privacy Policy</a>.
          </span>
      </app-checkbox>
      <app-checkbox
        data-qa="new-user-marketing"
        [formControlName]="'marketing'"
        [checked]="newUserForm.value.marketing"
        [required]="true"
        (checkBoxClicked)="newUserForm.controls.marketing.setValue($event)">
          <span class="font-4 bold400 black-10">
            I agree to receive marketing communications from Orca<br>and acknowledge that I can opt out at any time.
          </span>
      </app-checkbox>
    </div>
    <app-button
      data-qa="new-user-continue"
      class="self-stretch"
      [type]="'accent'"
      [disabled]="newUserForm.invalid || newUserForm.disabled"
      [bordersSquaredShape]="'full'"
      [size]="'large'"
      [additionalClasses]="'w-full'"
      (buttonClick)="continue()">
      Continue
    </app-button>
  </div>
</div>
